import React, { useState } from "react";
import "./CareerFAQ.css";
import careersImage from "../../Assets/career-right.png"; // your whole image file

const jobsData = [
  {
    title: "Overseas Education Counselor",
    description: `As an Overseas Education Counselor, you’ll be the first point of contact for students aspiring to study in a different country. You'll provide personalized guidance on study abroad programs, how to apply for foreign universities, and securing study abroad scholarships.`,
    responsibilities: [
      "Conduct counselling sessions to understand student goals",
      "Suggest suitable courses, destinations, and universities",
      "Guide on how to apply to study abroad and prepare applications",
      "Assist with scholarship and grant opportunities",
    ],
    candidate: [
      "Strong communication and interpersonal skills",
      "Knowledge of international education systems",
      "Passion for helping students achieve their dreams",
    ],
  },
  {
    title: "Documentation Executive",
    description:
      "The Documentation Executive ensures that every application, visa, and scholarship process is completed smoothly and accurately. Your attention to detail will help students avoid delays and secure their place in their chosen programs abroad.",
    responsibilities: [
      "Manage and verify application documents",
      "Coordinate with universities and embassies for processing",
      "Maintain accurate student records and timelines",
      "Assist in preparing study abroad masters program and undergraduate application files"
    ],
    candidate: [
      "Detail-oriented and highly organized",
      "Experience in document handling and compliance",
      "Ability to work with multiple cases at once",
    ],
  },
  {
    title: "Marketing Executive",
    description:
      "Our Marketing Executives promote Nova EduBridge, connecting us with students who dream of careers abroad and life in a different country. You’ll design and execute marketing campaigns that highlight our expertise in study abroad counselling and international career guidance.",
    responsibilities: [
      "Plan and run digital and offline marketing campaigns",
      "Promote services like study abroad grants, jobs abroad guidance, and University application support",
      "Manage social media and outreach activities",
      "Coordinate with the counselling team for event promotions"
    ],
    candidate: [
      "Creative mindset with a flair for storytelling",
      "Knowledge of digital marketing tools and trends",
      "Excellent communication and networking skills",
    ],
  },
];

export default function CareersSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="careers-container container mt-5">
      <div className="careers-left">
        <h2 className="section-title">Current Openings</h2>

        {jobsData.map((job, index) => (
          <div key={index} className="accordion-item">
            <button
              className={`accordion-header text-muted ${
                openIndex === index ? "active" : ""
              }`}
              onClick={() => toggleIndex(index)}
            >
              {index + 1}. {job.title}
              <span className="arrow">{openIndex === index ? "▲" : "▼"}</span>
            </button>

            {openIndex === index && (
              <div className="accordion-body">
                <p>{job.description}</p>

                <h4 className="text-muted">Key Responsibilities:</h4>
                <ul>
                  {job.responsibilities.map((res, i) => (
                    <li className="text-muted" key={i}>{res}</li>
                  ))}
                </ul>

                <h4 className="text-muted">Ideal Candidate:</h4>
                <ul>
                  {job.candidate.map((cand, i) => (
                    <li className="text-muted" key={i}>{cand}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="careers-right">
        <img src={careersImage} alt="Careers" />
      </div>
    </div>
  );
}
